import React from 'react'
import { IconProps } from './interfaces/IconProps.interface'

const Keynote = ({ color = "#000", ...rest }: IconProps) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <g clipPath="url(#clip0_7251_9250)">
                <path d="M8.66949 7.99967V13.333H11.3362V14.6663H4.66949V13.333H7.33616V7.99967H1.99749C1.63216 7.99967 1.39349 7.71301 1.46616 7.34834L2.53949 1.98434C2.61149 1.62434 2.96616 1.33301 3.33616 1.33301H12.6682C13.0368 1.33301 13.3928 1.61967 13.4655 1.98434L14.5388 7.34834C14.6108 7.70834 14.3655 7.99967 14.0075 7.99967H8.66949Z" fill="#6941C6" />
            </g>
            <defs>
                <clipPath id="clip0_7251_9250">
                    <rect width="16" height="16" fill={color} />
                </clipPath>
            </defs>
        </svg>

    )
}

export default Keynote